
import axios from 'axios';

// app config
import AppConfig from 'Constants/AppConfig';
import AuthHeader from 'Constants/AuthHeader';
import {
    TRAVELREPORT_ACTION,
    ALL_TRAVELREPORT,

} from 'Actions/types';

/**
 * MSK Findings Chart Actions
 */

   export const allTravelReport = (startdate,enddate,student) =>{
    
    var payload={
        "studentID":student,
        "startdate":startdate,
        "enddate":enddate
    }
    return (dispatch) => { 
        dispatch({ type:TRAVELREPORT_ACTION, });
        return axios.post(AppConfig.apiurl+'/api/studenttravelreport', payload,{ headers: AuthHeader.header })         
        .then(response => {             
            const allTravelReport=response.data.data;
            
            dispatch({ type:ALL_TRAVELREPORT, payload: allTravelReport });
            
        });
    
    }
}

